<template>
  <div />
</template>

<script>
import { useQuasar } from 'quasar';
import { onBeforeUnmount } from 'vue';

export default {
  setup() {
    const $q = useQuasar();
    let timer;

    onBeforeUnmount(() => {
      if (timer !== 0) {
        clearTimeout(timer);
        $q.loading.hide();
      }
    });
    const showLoading = () => {
      $q.loading.show();
    };
    showLoading();
  },
};
</script>
